export default __webpack_public_path__ + "static/media/BrandonGrotesque-Regular.11467f99.woff";